import { z } from 'zod'

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url('VITE_API_BASE_URL must be a valid URL'),
  VITE_APP_NAME: z.string().min(1),
  VITE_SENTRY_DSN: z.string().url().optional().or(z.literal('')),
  VITE_SENTRY_ENVIRONMENT: z.string().optional(),
})

type Env = z.infer<typeof envSchema>

const parsed = envSchema.safeParse(import.meta.env)

export const env = {
  get current(): Env {
    if (!parsed.success) {
      throw new Error(
        `Invalid environment variables:\n${parsed.error.errors
          .map((e) => `  - ${e.path.join('.')}: ${e.message}`)
          .join('\n')}`,
      )
    }
    return parsed.data
  },
  assertValid: () => {
    if (!parsed.success) {
      console.error(
        '%c❌ Invalid environment variables',
        'color:#d32f2f;font-weight:bold;font-size:14px',
        parsed.error.format(),
      )
      throw new Error('Environment validation failed. Check console for details.')
    }
  },
}
